export const error = { background: '#f34972', text: '#FFFFFF' };
export const success = { background: '#00cc6a', text: '#FFFFFF' };
